import useSWR from "swr";
import { getJunkValues } from "./service";
import { UseJunkValuesModel } from "./types";

const useJunkValues = (): UseJunkValuesModel => {
  const { data, error, isLoading, mutate } = useSWR(`/junk-values`, () =>
    getJunkValues(),
  );

  return {
    data: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useJunkValues;
